import moment from "moment-timezone";

const MS_PER_MINUTE = 60 * 1000;

/**
 * Converts UTC timestamps to "local" timestamps of an IANA time zone:
 * read with getUTC* getters they give the wall-clock time in that zone.
 * Uses the moment-timezone offset table directly, which is fast enough
 * to run for every bar.
 *
 * @param {string|null} timezone - unknown zones fall back to UTC
 * @returns {(utcMs: number) => number}
 */
export const createZonedTime = (timezone) => {
  const zone = timezone ? moment.tz.zone(timezone) : null;

  return (utcMs) => (zone ? utcMs - zone.utcOffset(utcMs) * MS_PER_MINUTE : utcMs);
};
